module.exports = __webpack_public_path__ + "main/assets/public/email/facebook-logo.e7d86e642ea224a1.png";